import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import { svgIconClasses, Skeleton } from '@mui/material';
import Box from '@mui/material/Box';
import TableMui from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCellMui, { tableCellClasses } from '@mui/material/TableCell';
import TableContainerMui, { tableContainerClasses } from '@mui/material/TableContainer';
import TableHeadMui from '@mui/material/TableHead';
import TableRowMui, { tableRowClasses } from '@mui/material/TableRow';
import TableSortLabelMui, { tableSortLabelClasses } from '@mui/material/TableSortLabel';
import { styled, css } from '@mui/material/styles';
import { visuallyHidden } from '@mui/utils';
import { times } from 'lodash';
import * as React from 'react';
import InfiniteScrollComponent from 'react-infinite-scroll-component';
import { shouldNotForwardProps, withUtility, spacing, shape } from '../../foundation/utils.js';
import { useIsMobile } from '../../hooks/use-is-mobile.js';
import '@mui/system';
import '../assist-chip/assist-chip.js';
import { Button } from '../button/button.js';
import '../card/card.js';
import '../checkbox/checkbox.js';
import '../container/container.js';
import '../dialog/dialog.js';
import '../divider/divider.js';
import '../donut/donut.js';
import '@mui/icons-material/ArrowBack';
import '@mui/material/Drawer';
import '@mui/icons-material/ContentCopyRounded';
import '../fast-copy/fast-copy.types.js';
import '../feedback-banner/feedback-banner.js';
import '../filter-chip-select/filter-chip-select.js';
import '../filter-chip/filter-chip.js';
import '../line/line.js';
import '../link/link.js';
import '../logo/logo.js';
import '../menu-list/menu-list.js';
import '../modal/modal.js';
import 'core-js/modules/es.parse-int.js';
import '../pagination/pagination.types.js';
import '../popover/popover.js';
import '../radio/radio.js';
import '../../foundation/theme/theme.js';
import '../select/select.js';
import '../snackbar/snackbar.js';
import '../snackbar/snackbar.types.js';
import { Stack } from '../stack/stack.js';
import '../stats/stats.js';
import '../stats/stats.types.js';
import '../switch/switch.js';
import './table.types.js';
import '../tabs/tabs.js';
import '../tag/tag.js';
import '../tag/tag.types.js';
import '../text-field/text-field.js';
import { Text } from '../text/text.js';
import { Tooltip } from '../tooltip/tooltip.js';

let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13;
const paddingCellDensity = density => {
  switch (density) {
    case 'comfortable':
      return `${spacing(5)} 0 ${spacing(5)} ${spacing(3)}`;
    case 'compact':
      return `${spacing(2)} 0 ${spacing(2)} ${spacing(3)}`;
    case 'standard':
      return `${spacing(3)} 0 ${spacing(3)} ${spacing(3)}`;
    default:
      return '0';
  }
};
const TableBoxContainer = styled(Box)(_t || (_t = _`
  width: 100%;
  height: 100%;
  .infinite-scroll-component__outerdiv {
    height: 100%;
  }
`));
const TableCell = styled(TableCellMui, {
  shouldForwardProp: shouldNotForwardProps
})(_t2 || (_t2 = _`
  ${0}
`), withUtility(({
  palette
}, {
  bgHeadCell,
  density,
  width
}) => css(_t3 || (_t3 = _`
      &.${0} {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: ${0};
        width: ${0};
        background: ${0};
      }
      &.${0} {
        border: none;
        font-size: 16px;
        padding: ${0};
        padding-right: 0;
        color: ${0};
        box-shadow: inset 0px -1px 0 ${0};
        &:hover {
          .${0} svg {
            opacity: 1 !important;
          }
        }
      }
      &.${0} {
        border: none;
        font-size: 16px;
        padding: ${0};
        padding-right: 0;
        color: ${0};
        font-weight: 400;
      }
    `), tableCellClasses.root, width ? `${width}px` : '168px', width ? `${width}px` : '168px', bgHeadCell ? bgHeadCell : 'none', tableCellClasses.head, spacing(3), palette('onSurface'), palette('surfaceVariant'), tableSortLabelClasses.root, tableCellClasses.body, paddingCellDensity(density || 'standard'), palette('onSurfaceVariant'))));
const TableSortLabel = styled(TableSortLabelMui)(_t4 || (_t4 = _`
  ${0}
`), withUtility(({
  palette
}) => css(_t5 || (_t5 = _`
      .${0} {
        color: ${0} !important;
      }
      .${0} {
        opacity: 1 !important;
      }
    `), tableSortLabelClasses.icon, palette('onPrimaryContainer'), tableSortLabelClasses.active)));
const TableContainer = styled(TableContainerMui)(_t6 || (_t6 = _`
  ${0}
`), withUtility(({
  palette
}) => css(_t7 || (_t7 = _`
      &.${0} {
        border-radius: ${0};
        border: 1px solid ${0};
      }
    `), tableContainerClasses.root, spacing(3), palette('surfaceVariant'))));
const TableRow = styled(TableRowMui)(_t8 || (_t8 = _`
  ${0}
  ${0}
`), withUtility(({
  palette
}) => css(_t9 || (_t9 = _`
      &:not(.${0}) {
        border-bottom: 1px solid ${0};
      }
      &:not(.${0}):last-child {
        border-bottom: none;
      }
    `), tableRowClasses.head, palette('surfaceVariant'), tableRowClasses.head)), withUtility(({
  palette
}, {
  hover
}) => {
  if (hover === false) {
    return css(_t10 || (_t10 = _``));
  }
  return css(_t11 || (_t11 = _`
      &:not(.${0}):hover {
        background: ${0} !important;
      }
    `), tableRowClasses.head, palette('surfaceAt3'));
}));
const LoadingRow = ({
  cellsQuantity
}) => jsx(TableRow, Object.assign({
  hover: true,
  role: "checkbox",
  tabIndex: -1,
  "aria-disabled": "true"
}, {
  children: times(cellsQuantity, cellCount => jsx(TableCell, Object.assign({
    scope: "row",
    padding: "none"
  }, {
    children: jsx(Skeleton, {
      width: "80%",
      height: 20,
      variant: "rounded",
      sx: {
        marginTop: 3,
        marginBottom: 3
      }
    })
  }), `skeleton-cell-${cellCount}`))
}));
const ButtonSort = styled(Button)(_t12 || (_t12 = _`
  margin-left: ${0};
  &:hover {
    .${0} svg {
      opacity: 1 !important;
    }
  }
`), spacing(2), tableSortLabelClasses.root);
function TableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,
    headCells,
    background
  } = props;
  const createSortHandler = property => event => {
    onRequestSort && onRequestSort(event, property);
  };
  const isMobile = useIsMobile();
  return jsx(TableHeadMui, {
    children: jsx(TableRow, {
      children: headCells.map(headCell => {
        var _a;
        return jsx(TableCell, Object.assign({
          sortDirection: orderBy === headCell.key ? order : false,
          bgHeadCell: background,
          onClick: headCell.sortable ? createSortHandler(headCell.key) : () => null,
          sx: {
            cursor: headCell.sortable ? 'pointer' : 'default'
          },
          width: headCell === null || headCell === void 0 ? void 0 : headCell.width
        }, {
          children: jsxs(Stack, Object.assign({
            direction: "row",
            justifyContent: (_a = headCell.justifyContent) !== null && _a !== void 0 ? _a : 'left',
            alignItems: "center"
          }, {
            children: [headCell.label, headCell.tooltip && jsx(Stack, Object.assign({
              ml: 2
            }, {
              children: jsx(Tooltip, Object.assign({
                trigger: isMobile ? 'click' : 'hover',
                title: headCell.tooltip,
                arrow: true,
                placement: "top"
              }, {
                children: jsx(InfoOutlinedIcon, {
                  fontSize: "small"
                })
              }))
            })), headCell.sortable && jsx(ButtonSort, Object.assign({
              variant: "text",
              size: "small",
              iconOnly: true
            }, {
              children: jsx(TableSortLabel, Object.assign({
                active: orderBy === headCell.key,
                direction: order
              }, {
                children: orderBy === headCell.key && jsx(Box, Object.assign({
                  component: "span",
                  sx: visuallyHidden
                }, {
                  children: order === 'desc' ? 'sorted descending' : 'sorted ascending'
                }))
              }))
            }))]
          }))
        }), headCell.key);
      })
    })
  });
}
const QUANTITY_NEW_ROWS = 10;
const QUANTITY_LOADING_ROWS = 5;
const QUANTITY_FIXED_ROWS = 2;
const ROW_HEIGHT = 60;
function Table({
  onRequestSort,
  onRequestPage,
  children,
  headCells = [],
  dataLength = 0,
  id,
  isLoading = false,
  maxPage = 100,
  infiniteScroll,
  bgHeadCell,
  maxHeight,
  minWidth,
  width,
  empty,
  emptyTitle = 'Nenhum resultado encontrado',
  emptySubtitle
}) {
  var _a, _b;
  const defaultSortEnabled = headCells.find(cell => cell.defaultSortOrder);
  const [order, setOrder] = React.useState((_a = defaultSortEnabled === null || defaultSortEnabled === void 0 ? void 0 : defaultSortEnabled.defaultSortOrder) !== null && _a !== void 0 ? _a : 'asc');
  const [orderBy, setOrderBy] = React.useState((_b = defaultSortEnabled === null || defaultSortEnabled === void 0 ? void 0 : defaultSortEnabled.key) !== null && _b !== void 0 ? _b : '');
  const [page, setPage] = React.useState(1);
  const scrollContainer = React.useRef(null);
  const handleRequestSort = React.useCallback((event, property) => {
    const sort = orderBy === property && order === 'asc' ? 'desc' : 'asc';
    setOrder(sort);
    setOrderBy(property);
    onRequestSort && onRequestSort({
      property,
      sort
    });
  }, [onRequestSort, order, orderBy]);
  const handleChangePage = () => {
    onRequestPage && onRequestPage(page + 1);
    setPage(prevPage => prevPage + 1);
  };
  const isLastPage = page >= maxPage;
  const cellsQuantity = headCells.length;
  // When loading new rows, scroll to the position for the new total height of table
  React.useEffect(() => {
    if (!scrollContainer.current || page <= 1) return;
    const totalScrollHeight = scrollContainer.current.scrollHeight;
    const scrollPosition = scrollContainer.current.scrollTop;
    const newLinesHeight = (QUANTITY_NEW_ROWS + QUANTITY_LOADING_ROWS + QUANTITY_FIXED_ROWS) * ROW_HEIGHT;
    const scrollVariation = totalScrollHeight - newLinesHeight - scrollPosition;
    // Scroll to the desired position, taking into account the current scroll variation until the end
    scrollContainer.current.scrollTo(0, totalScrollHeight - newLinesHeight - (scrollVariation > 0 ? scrollVariation : 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataLength, scrollContainer]);
  const canRenderLoadingNextPage = dataLength > 0 && !isLastPage && infiniteScroll;
  return jsx(TableBoxContainer, {
    children: jsx(InfiniteScrollComponent, Object.assign({
      dataLength: dataLength && dataLength + 5 || 10,
      next: infiniteScroll ? handleChangePage : () => null,
      hasMore: (infiniteScroll || false) && !isLastPage,
      scrollThreshold: 0.8,
      loader: null,
      scrollableTarget: id,
      style: {
        height: '100%'
      }
    }, {
      children: jsxs(TableContainer, Object.assign({
        id: id,
        sx: {
          height: '100%',
          maxHeight: maxHeight !== null && maxHeight !== void 0 ? maxHeight : 300
        },
        ref: scrollContainer
      }, {
        children: [jsxs(TableMui, Object.assign({
          stickyHeader: true,
          sx: {
            tableLayout: 'fixed',
            borderCollapse: 'collapse',
            minWidth: minWidth !== null && minWidth !== void 0 ? minWidth : 168 * cellsQuantity,
            width: width !== null && width !== void 0 ? width : '100%'
          },
          "aria-labelledby": "tableTitle"
        }, {
          children: [headCells && jsx(TableHead, {
            background: bgHeadCell,
            headCells: headCells,
            order: order,
            orderBy: orderBy,
            onRequestSort: handleRequestSort
          }), headCells && jsxs(TableBody, {
            children: [!isLoading && children, (isLoading || canRenderLoadingNextPage) && times(5, rowCount => jsx(LoadingRow, {
              cellsQuantity: cellsQuantity
            }, `skeleton-row-${rowCount}`))]
          }), !headCells && children]
        })), empty && jsxs(Stack, Object.assign({
          "data-testid": "empty-state",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          paddingY: 30,
          paddingX: 8,
          height: "100%"
        }, {
          children: [jsx(EmptyIcon, {
            children: jsx(ManageSearchOutlinedIcon, {})
          }), jsx(Text, Object.assign({
            variant: "h4",
            marginTop: 6,
            textAlign: "center"
          }, {
            children: emptyTitle
          })), jsx(Text, Object.assign({
            variant: "body2",
            color: "onSurfaceVariant",
            marginTop: 1,
            textAlign: "center"
          }, {
            children: emptySubtitle
          }))]
        }))]
      }))
    }))
  });
}
const EmptyIcon = styled(Stack)(_t13 || (_t13 = _`
  padding: ${0};
  border-radius: ${0};
  border: 1px solid ${0};
  background: ${0};
  .${0} {
    color: ${0};
  }
`), spacing(2), shape('medium'), withUtility(({
  palette
}) => palette('surfaceVariant')), withUtility(({
  palette
}) => palette('surfaceAt1')), svgIconClasses.root, withUtility(({
  palette
}) => palette('onSurfaceVariant')));

export { Table, TableCell, TableContainer, TableRow, TableSortLabel };
